export default __webpack_public_path__ + "static/media/zoom-in.144eefd4.png";